import { createElement } from "react";
import { ReactQuestionFactory } from "survey-react-ui";
import {
  CheckboxGroupQuestion,
  CheckboxGroupLargeQuestion,
  FileUploadQuestion,
  InputQuestion,
  PhoneNumberQuestion,
  RadioQuestion,
  RadioLargeQuestion,
  RadioCardQuestion,
  TextareaQuestion,
  LicensePlateQuestion,
  SelectorQuestion,
  SelectQuestion,
  AppointmentTimeSlotQuestion,
  DamageFromDirectionQuestion,
  DecisionTableQuestion,
  DatePickerQuestion,
  SignatureQuestion,
  TimePickerQuestion,
  FeatureListQuestion,
  DocumentExampleQuestion,
} from "../questions";
import { ViewQuestion } from "../questions/ViewQuestion";

export const registerQuestions = () => {
  ReactQuestionFactory.Instance.registerQuestion(
    "appointment-time-slot",
    (props: any) => createElement(AppointmentTimeSlotQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    "damage-from-direction",
    (props: any) => createElement(DamageFromDirectionQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    "decisionTable",
    (props: any) => createElement(DecisionTableQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("checkbox", (props: any) =>
    createElement(CheckboxGroupQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("fileupload", (props: any) =>
    createElement(FileUploadQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("datepicker", (props: any) =>
    createElement(DatePickerQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("timepicker", (props: any) =>
    createElement(TimePickerQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    "checkboxGroupLarge",
    (props: any) => createElement(CheckboxGroupLargeQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("input", (props: any) =>
    createElement(InputQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("radio", (props: any) =>
    createElement(RadioQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("radioLarge", (props: any) =>
    createElement(RadioLargeQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("radioCard", (props: any) =>
    createElement(RadioCardQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("featurelist", (props: any) =>
    createElement(FeatureListQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    "documentExample",
    (props: any) => createElement(DocumentExampleQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("licensePlate", (props: any) =>
    createElement(LicensePlateQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("phoneNumber", (props: any) =>
    createElement(PhoneNumberQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion(
    "repairAllowed",
    (props: any) => createElement(RadioQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("select", (props: any) =>
    createElement(SelectQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("selector", (props: any) =>
    createElement(SelectorQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("signature", (props: any) =>
    createElement(SignatureQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("textarea", (props: any) =>
    createElement(TextareaQuestion, props),
  );

  ReactQuestionFactory.Instance.registerQuestion("view", (props: any) =>
    createElement(ViewQuestion, props),
  );
};
